<template>
  <div v-if="display">
    <modal-layout-top :title="title" />
    <div class="content slider-modal">

      <div class="mrc-tabs">
          <div class="mrc-tab" :class="{ 'active': tab == 'overview' }" @click="tab = 'overview'">Översikt</div>
          <div class="mrc-tab" :class="{ 'active': tab == 'projects' }" @click="tab = 'projects'">Projekt</div>
        </div>

      <div class="slider-modal-fields">

        <template v-if="tab == 'overview'">
          <div class="field">
            <label class="label">Förnamn * </label>
            <input class="input" name="firstName" type="text" v-model="contact.firstName" v-validate="'required'">
            <div v-show="errors.has('firstName')" class="invalid-feedback">{{ errors.first('firstName') }}</div>
          </div>

          <div class="field">
            <label class="label">Efternamn * </label>
            <input class="input" name="lastName" type="text" v-model="contact.lastName" v-validate="'required'">
            <div v-show="errors.has('lastName')" class="invalid-feedback">{{ errors.first('lastName') }}</div>
          </div>

          <div class="field">
            <label class="label">Företag</label>
            <input class="input" name="role" type="text" v-model="contact.freeText">
          </div>

          <div class="field">
            <label class="label">Roll</label>
            <input class="input" name="role" type="text" v-model="contact.role">
            <div v-show="errors.has('role')" class="invalid-feedback">{{ errors.first('role') }}</div>
          </div>

          <div class="field">
            <label class="label">E-post</label>
            <input class="input" name="email" type="email" v-model="contact.email">
            <div v-show="errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</div>
          </div>

          <div class="field"></div>

          <div class="field">
            <label class="label">Mobilnummer</label>
            <input class="input" name="mobilePhone" type="tel" v-model="contact.mobilePhone">
            <div v-show="errors.has('mobilePhone')" class="invalid-feedback">{{ errors.first('mobilePhone') }}</div>
          </div>

          <div class="field">
            <label class="label">Direktnummer</label>
            <input class="input" name="phone" type="tel" v-model="contact.phone">
            <div v-show="errors.has('phone')" class="invalid-feedback">{{ errors.first('phone') }}</div>
          </div>
        </template>
        <template v-else-if="tab == 'projects'">
          <table style="margin: 0 1.5rem;">
            <thead>
              <tr>
                <th>Projekt</th>
                <th>Adress</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="project in contact.participantInProjects" :key="project.projectCode">
                <td>{{ project.projectCode }}</td>
                <td>{{ project.addressFormatted }}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
          <modal-layout-buttons :store-name="'contacts'"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import { MultiListSelect } from 'vue-search-select'
import MultiSelect from 'vue-multiselect'

export default {
  name: 'contact-new-modal',
  data () {
    return {
      contact: {
        contactId: 0,
        selectedCustomers: [],
        selectedProjects: [],
        firstName: null,
        lastName: null,
        phone: null,
        mobilePhone: null,
        email: null,
        role: null,
        projectId: null
      },
      tab: 'overview',
      submitted: false,
      projectSelected: false,
      showAddToProject: false,
      display: false,
      customerList: [],
      projectList: []
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons,
    MultiListSelect,
    MultiSelect
  },
  props: {
    id: {
      type: Number,
      required: false
    },
    role: {
      type: String,
      required: false
    },
    customerName: {
      type: String,
      required: false
    }
  },
  computed: {
    // ...mapState({
    //   projects: state => state.projects.all,
    //   customers: state => state.customers.all,
    //   contacts: state => state.contacts.all
    // }),
    title () {
      if (!this.id) {
        return 'Lägg till ny kontakt'
      } else {
        return (
          'Ändra kontakt ' + this.contact.firstName + ' ' + this.contact.lastName
        )
      }
    }
  },
  methods: {
    ...mapActions('contacts', [
      'getListData',
      'update',
      'create',
      'getById',
      'createProjectContact'
    ]),

    ...mapActions('customers', { getAllCustomers: 'getAll' }),

    closePanel () {
      this.$emit('closePanel', { response: this.contact })
    },
    save () {
      this.submitted = true
      this.$validator.validateAll()

      if (this.id) {
        this.update(this.contact).then(response => {
          this.contact = response.result
          this.$emit('pageChange')
          this.closePanel()
        })
      } else {
        this.create(this.contact).then(contact => {
          this.contact = contact

          if (this.contact.projectId) {
            if (this.contact.projectId) {
              this.createProjectContactMethod(contact.contactId)
            }
          }
          this.$emit('pageChange')
          this.closePanel()
        })
      }
    },
    selectedCustomersChange (customers, lastSelected) {
      this.contact.selectedCustomers = customers
    },
    selectedProjectsChange (projects, lastSelected) {
      this.contact.selectedProjects = projects
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    var promises = []

    promises.push(this.getAllCustomers().then((customers) => {
      this.customers = customers
      this.customerList = this.customers.map(x => ({ text: x.name, value: x.customerId }))
    }))

    if (this.id) {
      promises.push(this.getById(this.id).then(contact => {
        this.contact = contact.result
      }))
    } else {
      if (this.role) {
        this.contact.role = this.role
      }
      this.contact.freeText = this.customerName
    }

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>
<style lang="scss">
  .mrc-tabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    gap: 1rem;
    color: #666;

    .mrc-tab {
      cursor: pointer;

      &.active {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ContactModal.vue